// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2JzHr","additionalInfo":"AgreementModal_additionalInfo__12nVu"};